"use strict";
/**
 * Order Status
 * Handles order status tracking and cancellation
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderStatus = getOrderStatus;
exports.cancelExistingOrder = cancelExistingOrder;
const api_1 = require("../api");
/**
 * Get order status by order ID
 * @param orderId - Order ID to check
 * @returns Order object
 */
async function getOrderStatus(orderId) {
    try {
        const response = await (0, api_1.getOrder)(orderId);
        return response.orders[0];
    }
    catch (error) {
        console.error(`Failed to get order status for ${orderId}:`, error);
        throw error;
    }
}
/**
 * Cancel an order
 * @param orderId - Order ID to cancel
 * @returns Cancelled order object
 */
async function cancelExistingOrder(orderId) {
    try {
        console.log(`Cancelling order: ${orderId}`);
        const response = await (0, api_1.cancelOrder)(orderId);
        return response.orders[0];
    }
    catch (error) {
        console.error(`Failed to cancel order ${orderId}:`, error);
        throw error;
    }
}
